import React from 'react';
import { Hero } from '../components/Hero';
import { FeaturedEpisodes } from '../components/FeaturedEpisodes';
import { AboutHosts } from '../components/AboutHosts';
import { FoundersCarousel } from '../components/FoundersCarousel';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <main className="min-h-screen bg-archival-cream text-charcoal-900 selection:bg-gold/30 selection:text-charcoal-900" data-id="element-210">
      <div className="film-grain" aria-hidden="true" data-id="element-211" />

      <Hero data-id="element-212" />
      <FeaturedEpisodes data-id="element-213" />
      <AboutHosts data-id="element-214" />
      <FoundersCarousel data-id="element-215" />
      <Footer data-id="element-216" />
    </main>;
}